import * as React from "react";
import { SVGProps } from "react";

const Educare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 203 173"
    {...props}
  >
    <linearGradient id="a">
      <stop offset={0} stopColor="#43c465" />
      <stop offset={1} stopColor="#14a53c" />
    </linearGradient>
    <linearGradient
      xlinkHref="#a"
      id="b"
      x1={44.636}
      x2={45.303}
      y1={76.764}
      y2={31.431}
      gradientUnits="userSpaceOnUse"
    />
    <linearGradient
      id="c"
      x1={99.294}
      x2={52.628}
      y1={25.134}
      y2={23.134}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#33c2f7" />
      <stop offset={1} stopColor="#0f95b2" />
    </linearGradient>
    <linearGradient
      xlinkHref="#a"
      id="d"
      x1={45.191}
      x2={44.524}
      y1={141.928}
      y2={87.928}
      gradientUnits="userSpaceOnUse"
    />
    <linearGradient
      id="e"
      x1={108.237}
      x2={148.904}
      y1={25.148}
      y2={24.481}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#03b7f9" />
      <stop offset={1} stopColor="#0f95b2" />
    </linearGradient>
    <linearGradient
      xlinkHref="#a"
      id="f"
      x1={158.283}
      x2={156.95}
      y1={78.513}
      y2={32.514}
      gradientUnits="userSpaceOnUse"
    />
    <linearGradient
      xlinkHref="#a"
      id="g"
      x1={159.201}
      x2={158.534}
      y1={144.891}
      y2={88.891}
      gradientUnits="userSpaceOnUse"
    />
    <linearGradient
      id="h"
      x1={100.381}
      x2={50.381}
      y1={147.293}
      y2={148.626}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#fff58e" />
      <stop offset={1} stopColor="#ffca20" />
    </linearGradient>
    <linearGradient
      id="i"
      x1={106.098}
      x2={144.098}
      y1={147.466}
      y2={149.466}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#feda5a" />
      <stop offset={1} stopColor="#ffca20" />
    </linearGradient>
    <path fill="url(#b)" d="M0 86h89L33 30.5z" />
    <path fill="url(#c)" d="M102 0v50.5L51.5 0z" />
    <path fill="url(#d)" d="m89 86-55.5 56L0 86z" />
    <path fill="url(#e)" d="M102 50.5 152.3 0H102z" />
    <path fill="url(#f)" d="m203 86-33.5-55.5L114 86z" />
    <path fill="url(#g)" d="M170.5 142 114 86h89z" />
    <path fill="url(#h)" d="M102 121.5V173H51.5z" />
    <path fill="url(#i)" d="M152.3 173H102v-51.5z" />
  </svg>
);

export default Educare;
